import React from 'react';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Permission } from '@/services/rolesPermissionsService';
import { getPermissionDisplayName, getPermissionDescription } from '@/auth/permissions';

interface PermissionFormModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  editingPermission: Permission | null;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  onReset: () => void;
}

export const PermissionFormModal: React.FC<PermissionFormModalProps> = ({
  isOpen,
  onOpenChange,
  editingPermission,
  onSubmit,
  isLoading,
  onReset
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            Editar Permiso
          </DialogTitle>
          <DialogDescription>
            Modifica la información del permiso seleccionado. Solo se pueden editar el nombre para mostrar, descripción y categoría.
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={onSubmit} className="space-y-4">
          <div>
            <Label htmlFor="permission_display_name">Nombre para mostrar</Label>
            <Input
              id="permission_display_name"
              name="display_name"
              defaultValue={editingPermission?.display_name || getPermissionDisplayName(editingPermission?.name || '')}
              placeholder="ej: Gestionar Usuarios"
            />
          </div>
          <div>
            <Label htmlFor="permission_description">Descripción</Label>
            <Textarea
              id="permission_description"
              name="description"
              defaultValue={editingPermission?.description || getPermissionDescription(editingPermission?.name || '') || ''}
              placeholder="Describe qué permite hacer este permiso"
            />
          </div>
          <div>
            <Label htmlFor="permission_category">Categoría</Label>
            <Input
              id="permission_category"
              name="category"
              defaultValue={editingPermission?.category || 'general'}
              placeholder="ej: usuarios, tramites, general"
            />
          </div>
          <div className="flex gap-2 pt-4">
            <Button type="submit" disabled={isLoading}>
              Actualizar
            </Button>
            <Button 
              type="button" 
              variant="outline" 
              onClick={() => {
                onOpenChange(false);
                onReset();
              }}
            >
              Cancelar
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};